// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__WZ8ia","rightAdornment":"Header_rightAdornment__2wNJr"};